import SaleTable from '../../sales/saleTable/SaleTable.vue';
import Photo from '../../../components/photo/Photo.vue';

export default {
  components: { SaleTable, Photo },
  data() {
    return {
      tableHeaders: [
        {
          text: 'Название',
          value: 'product.name',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Количество',
          value: 'quantity',
          sortable: false,
          align: 'left',
        },
        // { text: 'Серийный номер', value: 'barcode.code', sortable: false, align: 'right' },
        // { text: 'Цена', value: 'cost', sortable: false, align: 'right' },
        { text: 'Бонусы', value: 'bonuses', sortable: false, align: 'right' },
      ],
      history: [],
      showHistoryID: false,
      editStatuses: ['adminReview', 'draft', 'redo'],
      showPhoto: false,
      currentPhoto: null,
      showPdf: false,
      currentPdf: null,
      isLoadPage: false,
      showAllInfo: null,
    };
  },
  watch: {
    objectsList(list) {
      if (list.length) {
        const showAllInfo = {};
        list.forEach((item) => {
          showAllInfo[item.id] = false;
        });
        this.showAllInfo = showAllInfo;
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    objectsList() {
      return this.$store.state.objects.objects || [];
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    enableEditing(object) {
      return object.status === 'draft' || object.status === 'redo';
    },
    showInfo(objectId) {
      this.showAllInfo[objectId] = !this.showAllInfo[objectId];
    },
    edit(object) {
      this.$router.push(`/object/${object.action_id}/${object.id}`);
    },
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },
    addObject(id) {
      this.$store.dispatch('objects/GetObject', id);
      this.$router.push(`/object/${id}`);
    },
    showHistory(id) {
      const object = this.objectsList.filter(item => item.id === id);
      this.history = object.length ? object[0].history : [];
      this.showHistoryID = this.showHistoryID !== id ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo':
          return 'color-orange';
        case 'draft':
          return 'color-gray';
        case 'adminReview':
          return 'color-blue';
        case 'declined':
          return 'color-red';
        case 'paid':
          return 'color-green';
        case 'approved':
          return 'color-green';
        case 'verified':
          return 'color-green';
        default:
          return '';
      }
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    CheckPDF(photo) {
      if (photo.base64) {
        return photo.base64.indexOf('/pdf;') !== -1;
      }
      if (photo.url) {
        return photo.url.indexOf('.pdf') !== -1;
      }
      return false;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
  },
  mounted() {
    this.$store.dispatch('objects/GetObjects', {
      profile_id: this.user.profile_id,
    });
  },
};
